import { render, staticRenderFns } from "./TaskUserIdentity.vue?vue&type=template&id=62aefdf0"
import script from "./TaskUserIdentity.vue?vue&type=script&lang=js"
export * from "./TaskUserIdentity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62aefdf0')) {
      api.createRecord('62aefdf0', component.options)
    } else {
      api.reload('62aefdf0', component.options)
    }
    module.hot.accept("./TaskUserIdentity.vue?vue&type=template&id=62aefdf0", function () {
      api.rerender('62aefdf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Task/TaskElement/TaskUserIdentity.vue"
export default component.exports